import React, { useState } from "react";

const faqs = [
  {
    q: "Is Shopify Plus suitable for small businesses?",
    a: "Shopify Plus is generally recommended for businesses with growing operations, higher order volumes, multiple sales channels, or advanced ecommerce requirements. Smaller businesses often begin with Shopify and move to Shopify Plus as they expand.",
  },
  {
    q: "Can you migrate my existing ecommerce website to Shopify Plus?",
    a: "Yes. We provide Shopify migration services for businesses moving from platforms such as Magento, WooCommerce, Adobe Commerce, BigCommerce, OpenCart, and custom ecommerce systems. We carefully migrate products, customers, orders, content, and SEO data wherever possible.",
  },
  {
    q: "Do you provide Shopify Plus support after launch?",
    a: "Yes. Our team offers ongoing Shopify Plus support, maintenance, performance improvements, troubleshooting, and feature enhancements after your store goes live.",
  },
  {
    q: "Can Shopify Plus support B2B ecommerce?",
    a: "Yes. Shopify Plus includes powerful B2B capabilities such as company accounts, custom pricing, payment terms, wholesale catalogs, and bulk ordering features. We can also build custom workflows to match your business processes.",
  },
  {
    q: "Do you provide Shopify Plus development services across the UAE?",
    a: "Yes. Mean3 provides Shopify Plus development services across the UAE. Although our team is based in Dubai, we work with businesses throughout the UAE through online collaboration and dedicated project communication.",
  },
];

export default function Section9() {
  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prev) => prev.map((item, idx) => (idx === index ? !item : false)));
  };

  return (
    <div className="w-full Section9 mt-[8%] md:mt-[30px]">
        {/* Why Mean3 */}
        <div className="w-100 md:w-100 mx-auto text-center bg-[#F9F9F9] rounded-[8px] p-[5%]">
          <h2 className="text-[22px] md:text-[28px] font-bold text-[#DA2128] leading-[28px] md:leading-[36px] my-[0.5em]">
            Why Mean3?
          </h2>
          <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-4">
            Choosing a Shopify Plus development agency is about more than
            technical skills. You need a team that understands ecommerce,
            listens to your business goals, and delivers solutions that make
            day-to-day operations easier.
          </p>
          <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
            At Mean3, we combine strategy, design, development, and
            long-term support to help businesses build reliable ecommerce
            experiences. Whether you're launching your first enterprise
            store or expanding across multiple markets, our Shopify Plus
            experts are ready to support your journey.
          </p>
        </div>
      <div className="w-full section9-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={faq.q}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              style={{
                background:
                  "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.q}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div
                className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}
              >
                <br />
                <p className="mb-5">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}